import React, { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import clsx from 'clsx';

// COMPONENTS
import styles from 'styles/common/layout.module.scss';
import useGetUserData from 'customHooks/useGetUserData';
import useClientPortalNotifications from 'customHooks/useClientPortalNotifications';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';

function LayoutWrapper() {
  const navigate = useNavigate();
  const { isForcePassword } = useGetUserData();
  useClientPortalNotifications();

  useEffect(() => {
    if (isForcePassword === 1) {
      navigate('/contact-set-password');
    }
    return undefined;
  }, [isForcePassword]);

  return (
    <Box className={isForcePassword === 1 ? 'force-password-set' : ''}>
      <Navbar />

      <Box className="d-flex align-items-start">
        <Sidebar />
        <Box className={clsx(styles.mainContainer, 'position-relative mainContainer')}>
          <Container className="p-0" maxWidth="xl" fixed>
            <Outlet />
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

export default LayoutWrapper;
